import { Checkbox, Table } from "antd";
import type { ColumnsType } from "antd/es/table";
import { UserApiService } from "features/users/api/user-api.service";
import { useState, useEffect } from "react";
import { capitalizeFirst } from "routes/utils";

export const PermissionAgentRole = ({ PrivilegeState, setPermissions, permissions }: any) => {
  const [data, setData] = useState<any>([]);
  const [tableData, setTableData] = useState<any[]>([]);
  const [permissionTypes, setPermissionTypes] = useState<string[]>([]);
  const [expandedRowKeys, setExpandedRowKeys] = useState<any[]>([]);

  // Fetch permissions from API
  const initial = async () => {
    try {
      const apires: any = await UserApiService().getprivilepermissions("" as any);
      setData(apires);

      if (apires.length > 0) {
        setPermissionTypes(Object.keys(apires[0].permissions));
      }
    } catch (error) {
      console.error(error);
    }
  };

  // Transform API data to table tree
  useEffect(() => {
    if (data?.length) {
      const transform: any = (items: any[], parentKey: string | null = null) =>
        items
          .filter((i: any) => i.parentKey === parentKey)
          .map((i: any) => {
            const children = transform(items, i.key);

            return {
              key: i.key,
              page: i.title,
              permissions: i.permissions,
              children: children.length ? children : undefined,
            };
          });

      setTableData(transform(data));
    }
  }, [data]);

  // Load initial privileges
  useEffect(() => {
    if (PrivilegeState?.length) {
      const formatted: any = {};
      PrivilegeState.forEach((item: any) => {
        formatted[item.key] = { ...item.permissions };
      });

      setPermissions(formatted);
    }
  }, [PrivilegeState]);


  // Toggle single permission (parent or child)
  const togglePermission = (rowKey: string, perm: string) => {
    const updated: any = { ...permissions };

    const findAndToggle = (items: any[]) => {
      for (const item of items) {
        if (item.key === rowKey) {
          const newValue = !(updated[item.key]?.[perm] ?? item.permissions[perm]);
          updated[item.key] = { ...updated[item.key], [perm]: newValue };

          // If parent, toggle all children recursively
          if (item.children) {
            const toggleChildren = (children: any[]) => {
              children.forEach((child) => {
                updated[child.key] = { ...updated[child.key], [perm]: newValue };
                if (child.children) toggleChildren(child.children);
              });
            };
            toggleChildren(item.children);
          }
          break;
        }
        if (item.children) findAndToggle(item.children);
      }
    };

    findAndToggle(tableData);
    setPermissions(updated);
  };

  // Toggle entire column via header checkbox
  const toggleAllPermission = (perm: string, checked: boolean) => {
    const updated: any = { ...permissions };

    const assign = (item: any) => {
      updated[item.key] = updated[item.key] || {};
      updated[item.key][perm] = checked;

      if (item.children) item.children.forEach(assign);
    };

    tableData.forEach(assign);
    setPermissions(updated);
  };

  // Auto-expand all parent rows
  useEffect(() => {
    const keys = tableData.filter(item => item.children && item.children.length > 0).map(item => item.key);
    setExpandedRowKeys(keys);
  }, [tableData]);

  // Table columns
  const columns: ColumnsType<any> = [
    {
      title: "Pages",
      dataIndex: "page",
      key: "page",
      render: (text) => <b>{text}</b>,
    },
    ...permissionTypes.map((perm: any) => {


      return {
        // title: (
        //   <Checkbox
        //     onChange={(e) => toggleAllPermission(perm, e.target.checked)}
        //     disabled={perm === "add" || perm === "print" || perm === "enable"}  // ✅ Disable column "add"
        //     checked={
        //       tableData.length > 0 &&
        //       tableData.every(
        //         (row) =>
        //           permissions[row.key]?.[perm] ??
        //           row.permissions?.[perm] ??
        //           false
        //       )
        //     }
        //   >
        //     {capitalizeFirst(perm)}
        //   </Checkbox>
        // ),
        title: (
          <Checkbox className="rol_check"
            onChange={(e) => toggleAllPermission(perm, e.target.checked)}
            disabled={perm === "add" || perm === "print" || perm === "enable"}
            checked={
              tableData.length > 0 &&
              tableData.every(
                (row) =>
                  permissions[row.key]?.[perm] ??
                  row.permissions?.[perm] ??
                  false
              )
            }
          >
            {
              perm === "print"
                ? "Print / Export"
                : perm === "enable"
                  ? "Enable / Disable"
                  : capitalizeFirst(perm)
            }
          </Checkbox>
        ),

        key: perm,
        render: (_: any, record: any) => {
          const isCoupon = record.page === "Coupon";

          return (
            <Checkbox
              className="rol_check"
              disabled={
                // Coupon page → only Add enabled, Print & Enable disabled
                // Other pages → Add disabled

                (!isCoupon && perm === "add") || // ← SAME AS YOUR ORIGINAL

                // NEW: Print should be enabled only for 4 pages
                (!["Transactions", "Group Registration", "Participant List", "Invoice List"]
                  .includes(record.page) && perm === "print") ||

                ([
                  "Event Management",
                  "Event List",
                  "Coupon"
                ].includes(record.page) && perm === "delete") ||
                // Your original Enable logic → keep disabled
                (!isCoupon && perm === "enable")
              }
              checked={
                permissions[record.key]?.[perm] ??
                record.permissions?.[perm] ??
                false
              }
              onChange={() => togglePermission(record.key, perm)}
            />
          );
        },
      };
    }),

  ];

  useEffect(() => {
    initial();
  }, []);

  return (
    <Table
      columns={columns}
      dataSource={tableData}
      pagination={false}
      className="setrole_table"
      style={{ border: "1px solid #ebe7e7", borderRadius: "8px" }}
      expandable={{
        expandedRowKeys,
        onExpand: (expanded, record) => {
          setExpandedRowKeys((prev) => {
            if (expanded) {
              return [...prev, record.key];
            } else {
              return prev.filter((k) => k !== record.key);
            }
          });
        },
        childrenColumnName: "children",
      }}
    />
  );
};
